var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 19.2502L15.2689 15.2691M15.2689 15.2691C15.9498 14.5881 16.49 13.7797 16.8586 12.8899C17.2271 12.0002 17.4168 11.0466 17.4168 10.0835C17.4168 9.12047 17.2271 8.16685 16.8586 7.2771C16.49 6.38736 15.9498 5.57892 15.2689 4.89794C14.5879 4.21696 13.7794 3.67678 12.8897 3.30823C12 2.93969 11.0463 2.75 10.0833 2.75C9.12023 2.75 8.1666 2.93969 7.27686 3.30823C6.38712 3.67678 5.57868 4.21696 4.89769 4.89794C3.52239 6.27324 2.74976 8.13855 2.74976 10.0835C2.74976 12.0285 3.52239 13.8938 4.89769 15.2691C6.273 16.6444 8.13831 17.417 10.0833 17.417C12.0282 17.417 13.8936 16.6444 15.2689 15.2691Z",
    stroke: "#FDF7E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchlight);
export default __webpack_public_path__ + "static/media/searchlight.798bda65ecf0751d0b48188c0b953863.svg";
export { ForwardRef as ReactComponent };